module.exports = __webpack_public_path__ + "img/scout-1.0c78f288.jpg";